/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

// Fisher-Yates algorithm
// parameters = (array, number of items that should be returned = default 1)
const randomize = ([...arr] = [], n = 1) => {
  let m = arr.length
  while (m) {
    const i = Math.floor(Math.random() * m--)
    ;[arr[m], arr[i]] = [arr[i], arr[m]]
  }
  return arr.slice(0, n)
}

export default randomize
